<template>
  <div>
    <h1>Vous n'êtes pas connecté à l'extranet</h1>
    <!-- Autres contenus ou fonctionnalités peuvent être ajoutés ici -->
  </div>
</template>

<script>
export default {
  // Votre logique de composant si nécessaire
};
</script>

<style scoped>
/* Vos styles CSS spécifiques à ce composant si nécessaire */
</style>
